import * as React from 'react';

import { PublicAnnouncements } from '../../shared/announcements/PublicAnnoucements';

export interface IPublicLayoutProps {
    children: React.ReactNode;
}

export function PublicLayout(props: IPublicLayoutProps) {
    return (
        <>
            <div className="app-container">
                <PublicAnnouncements />
                <header className="top-nav print-hide-display">
                    <div className="logo-container">
                        <img
                            className="logo-img rounded"
                            src="/images/CheckmateLogo.svg"
                            alt="Checkmate Logo"
                        />
                    </div>
                    <div className="nav-menu-item-container" />
                </header>
                <div className="app-body">
                    <aside className="left-nav print-hide-display" />
                    <div className="col-sm-10 main-display" style={{ padding: '50px' }}>
                        {props.children}
                    </div>
                </div>
            </div>
        </>
    );
}
